import { render } from "./ContactoEmergSection.vue?vue&type=template&id=05f5ccc7"
import script from "./ContactoEmergSection.vue?vue&type=script&lang=js"
export * from "./ContactoEmergSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__